const ENTITY = "MOU SOLUTIONS S.A.S.";
const NIT = "901935902-1";
const ADDRESS = "Cra 8 #5-59 Oficina 506, Fusagasugá, Cundinamarca, Colombia";
const PHONE = "+57 322 908 0554";
const WEB = "www.meu-aliado.com";

const missionSnippet =
  "Facilitamos el acceso, comprensión y gestión de productos financieros del mercado colombiano mediante intermediación transparente y tecnológica, conectando a personas y empresas con entidades financieras a través del modelo de finanzas abiertas.";

const visionSnippet =
  "Ser el principal auxiliar financiero de Colombia en el ecosistema de finanzas abiertas para 2030, reconocido por generar valor institucional, aumentar la bancarización efectiva y construir relaciones sostenibles entre usuarios y el sistema financiero.";

export const institutionalPages = {
  "/trabaja-con-nosotros": {
    eyebrow: "Talento MEU Aliado",
    title: "Trabaja con nosotros",
    subtitle:
      "Únete a un equipo que transforma la experiencia financiera en Colombia. Buscamos personas apasionadas por la tecnología, las finanzas y el impacto social.",
    badges: ["Fintech · Finanzas abiertas", "Trabajo híbrido según rol"],
    sections: [
      {
        id: "por-que",
        title: "Por qué MEU Aliado",
        paragraphs: [
          missionSnippet,
          "En MOU Solutions construimos productos que centralizan información financiera, habilitan simuladores de CDT, FIC y pensiones, y acompañan a empresas con soluciones como CFO fraccional y gestión de caja. Creemos en equipos multidisciplinarios, decisiones basadas en datos y comunicación clara con usuarios y aliados.",
        ],
      },
      {
        id: "perfiles",
        title: "Perfiles que buscamos",
        lists: [
          {
            items: [
              "Desarrollo de software (frontend, backend, integraciones API).",
              "Análisis financiero, riesgos y cumplimiento (SARLAFT, protección de datos).",
              "Producto digital, UX y educación financiera.",
              "Comercial B2B y relacionamiento con entidades financieras.",
              "Operaciones, atención al usuario y gestión de PQR.",
            ],
          },
        ],
      },
      {
        id: "cultura",
        title: "Nuestra cultura",
        paragraphs: [
          "Promovemos ambientes de aprendizaje continuo, respeto por la diversidad y compromiso con la transparencia hacia el usuario final. Valoramos la autonomía con responsabilidad y la colaboración entre áreas técnicas, financieras y comerciales.",
        ],
      },
      {
        id: "postular",
        title: "Cómo postular",
        paragraphs: [
          "Envía tu hoja de vida y una breve carta de motivación al correo colaboradores@meu-aliado.com indicando el área de interés. Revisamos cada aplicación y te contactamos si tu perfil coincide con una vacante abierta o futura.",
        ],
        links: [{ label: "Conoce nuestro equipo", path: "/quienes-somos" }],
      },
    ],
    sidebar: {
      title: "Datos de la empresa",
      lines: [`${ENTITY}`, `NIT ${NIT}`, ADDRESS],
    },
    cta: {
      title: visionSnippet.split(",")[0],
      text: visionSnippet,
    },
    relatedLinks: [
      { label: "¿Quiénes somos?", path: "/quienes-somos" },
      { label: "Centro de ayuda", path: "/centro-de-ayuda" },
    ],
  },

  "/centro-de-ayuda": {
    eyebrow: "Soporte",
    title: "Centro de ayuda",
    subtitle:
      "Encuentra respuestas sobre MEU Aliado, nuestros productos y canales de atención. Estamos para acompañarte en tu gestión financiera.",
    sections: [
      {
        id: "que-es",
        title: "¿Qué es MEU Aliado?",
        paragraphs: [
          "MEU Aliado es una plataforma auxiliar del ecosistema financiero colombiano que centraliza información de productos como CDT, FIC y pensiones voluntarias, y facilita su comparación y vinculación con entidades aliadas bajo estándares de finanzas abiertas.",
        ],
      },
      {
        id: "temas",
        title: "Temas frecuentes",
        lists: [
          {
            title: "Cuenta y acceso",
            items: [
              "Registro e inicio de sesión en la sección Personas o Empresas.",
              "Recuperación de contraseña desde la pantalla de autenticación.",
              "Vinculación de productos financieros mediante finanzas abiertas.",
            ],
          },
          {
            title: "Productos",
            items: [
              "Simuladores de CDT y FIC disponibles en el menú Personas.",
              "Información sobre pensiones voluntarias y planificación.",
              "Soluciones empresariales: CFO fraccional, gestión de caja y más.",
            ],
          },
          {
            title: "Seguridad y privacidad",
            items: [
              "Autorización previa para consultar datos financieros.",
              "Consulta nuestra política de protección de datos.",
              "Reporte de actividad sospechosa a través de canales oficiales.",
            ],
          },
        ],
        links: [
          { label: "Protección de datos", path: "/politica-tratamiento-datos" },
          { label: "Términos de uso", path: "/terminos-y-condiciones" },
        ],
      },
      {
        id: "canales",
        title: "Canales de contacto",
        lists: [
          {
            items: [
              `Teléfono: ${PHONE} (horario hábil, lunes a viernes).`,
              "Correo general: info@meu-aliado.com",
              "Privacidad y datos: protecciondatos@meu-aliado.com",
              "PQR y consumidor financiero: consumidor@meu-aliado.com",
            ],
          },
        ],
        links: [{ label: "Atención al consumidor financiero", path: "/atencion-consumidor-financiero" }],
      },
    ],
    cta: {
      title: "¿No encontraste lo que buscabas?",
      text: "Escríbenos describiendo tu consulta. Nuestro equipo te orientará sobre el producto, trámite o canal adecuado dentro del ecosistema MEU Aliado.",
    },
    relatedLinks: [
      { label: "Tarifas", path: "/tarifas" },
      { label: "Transparencia", path: "/transparencia" },
    ],
  },

  "/gobierno-corporativo": {
    eyebrow: "Legalidades",
    title: "Gobierno corporativo",
    subtitle:
      "Estructura de gobierno, principios éticos y compromisos de transparencia de MOU Solutions como auxiliar del sistema financiero colombiano.",
    badges: [`${ENTITY} · NIT ${NIT}`],
    sections: [
      {
        id: "marco",
        title: "Marco de gobierno",
        paragraphs: [
          "MOU SOLUTIONS S.A.S. opera bajo la legislación societaria colombiana y las normas aplicables a intermediación y servicios auxiliares del sector financiero. Nuestro gobierno corporativo se fundamenta en la transparencia, la rendición de cuentas y la protección del usuario.",
        ],
      },
      {
        id: "organos",
        title: "Órganos de administración",
        lists: [
          {
            items: [
              "Asamblea de accionistas: máxima autoridad de decisión societaria.",
              "Representante legal: ejerce la administración y representación judicial y extrajudicial.",
              "Comités internos de cumplimiento, riesgos y protección de datos según la naturaleza de la operación.",
            ],
          },
        ],
      },
      {
        id: "principios",
        title: "Principios rectores",
        lists: [
          {
            items: [
              "Transparencia en la relación con usuarios, aliados y autoridades.",
              "Ética comercial y prevención de conflictos de interés.",
              "Cultura de cumplimiento normativo (SARLAFT, protección de datos, consumidor financiero).",
              "Innovación responsable alineada con finanzas abiertas.",
            ],
          },
        ],
      },
      {
        id: "informacion",
        title: "Información corporativa",
        paragraphs: [
          `Razón social: ${ENTITY}. NIT: ${NIT}. Domicilio: ${ADDRESS}. Sitio web: ${WEB}.`,
          "La información societaria de carácter público puede solicitarse a través de los canales de transparencia y atención al usuario.",
        ],
        links: [{ label: "Transparencia y acceso a la información", path: "/transparencia" }],
      },
    ],
    cta: {
      title: "Compromiso institucional",
      text: missionSnippet,
    },
    relatedLinks: [
      { label: "SARLAFT", path: "/sarlaft" },
      { label: "Protección de datos", path: "/politica-tratamiento-datos" },
    ],
  },

  "/sarlaft": {
    eyebrow: "Legalidades",
    title: "SARLAFT",
    subtitle:
      "Sistema de Administración del Riesgo de Lavado de Activos, Financiación del Terrorismo y Financiación de la Proliferación de Armas de Destrucción Masiva.",
    badges: ["Cumplimiento · Prevención de riesgos"],
    sections: [
      {
        id: "objetivo",
        title: "Objetivo del programa",
        paragraphs: [
          `${ENTITY} implementa un programa SARLAFT alineado con la normativa colombiana vigente, orientado a identificar, prevenir y mitigar riesgos de lavado de activos, financiación del terrorismo y delitos conexos en el desarrollo de sus actividades como plataforma auxiliar financiera.`,
        ],
      },
      {
        id: "componentes",
        title: "Componentes principales",
        lists: [
          {
            items: [
              "Política de conocimiento del cliente y debida diligencia.",
              "Segmentación y monitoreo de operaciones inusuales o sospechosas.",
              "Capacitación periódica del personal en prevención de riesgos.",
              "Reportes a la UIAF cuando corresponda según la normativa.",
              "Revisión y actualización anual del programa de cumplimiento.",
            ],
          },
        ],
      },
      {
        id: "usuarios",
        title: "Compromiso con los usuarios",
        paragraphs: [
          "Solicitamos información veraz al momento del registro y vinculación de productos. Estos controles protegen el ecosistema financiero y garantizan un entorno seguro para todos los participantes de MEU Aliado.",
        ],
      },
      {
        id: "reporte",
        title: "Canales de reporte",
        paragraphs: [
          "Si identifica una operación sospechosa relacionada con nuestros servicios, comuníquese a cumplimiento@meu-aliado.com o al teléfono de atención. Toda comunicación será tratada con confidencialidad conforme a la ley.",
        ],
      },
    ],
    cta: {
      title: "Integridad y confianza",
      text: "La prevención del riesgo LA/FT es parte esencial de nuestra misión de intermediación transparente y responsable en el mercado financiero colombiano.",
    },
    relatedLinks: [
      { label: "Gobierno corporativo", path: "/gobierno-corporativo" },
      { label: "Protección de datos", path: "/politica-tratamiento-datos" },
    ],
  },

  "/terminos-y-condiciones": {
    eyebrow: "Legalidades",
    title: "Términos y condiciones de uso",
    subtitle:
      "Condiciones que rigen el acceso y uso de la plataforma MEU Aliado, sus simuladores, contenidos y servicios de intermediación.",
    badges: ["Vigencia: febrero 2025"],
    sections: [
      {
        id: "aceptacion",
        title: "1. Aceptación",
        paragraphs: [
          `Al acceder a ${WEB} o a la aplicación MEU Aliado, el usuario acepta estos términos y declara haber leído la política de tratamiento de datos personales. Si no está de acuerdo, debe abstenerse de utilizar la plataforma.`,
        ],
      },
      {
        id: "servicio",
        title: "2. Naturaleza del servicio",
        paragraphs: [
          "MEU Aliado actúa como auxiliar e intermediario tecnológico. La contratación de productos financieros (CDT, FIC, pensiones, entre otros) se realiza directamente con la entidad financiera aliada, conforme a sus propios términos y condiciones.",
          "Los simuladores y proyecciones tienen carácter informativo y no constituyen oferta vinculante hasta que la entidad financiera confirme condiciones definitivas.",
        ],
      },
      {
        id: "cuenta",
        title: "3. Cuenta de usuario",
        lists: [
          {
            items: [
              "El usuario es responsable de la veracidad de la información registrada.",
              "Debe mantener la confidencialidad de sus credenciales de acceso.",
              "MOU Solutions puede suspender cuentas ante uso fraudulento o incumplimiento de estos términos.",
            ],
          },
        ],
      },
      {
        id: "propiedad",
        title: "4. Propiedad intelectual",
        paragraphs: [
          "Marcas, diseños, software y contenidos de MEU Aliado son propiedad de MOU SOLUTIONS S.A.S. o de sus licenciantes. Queda prohibida su reproducción no autorizada.",
        ],
      },
      {
        id: "limitacion",
        title: "5. Limitación de responsabilidad",
        paragraphs: [
          "MOU Solutions no garantiza disponibilidad ininterrumpida del servicio y no responde por decisiones de inversión tomadas exclusivamente con base en simulaciones. El usuario debe verificar condiciones finales con la entidad financiera contratante.",
        ],
      },
      {
        id: "ley",
        title: "6. Ley aplicable",
        paragraphs: [
          "Estos términos se rigen por la legislación de la República de Colombia. Cualquier controversia se someterá a las autoridades competentes del domicilio de MOU SOLUTIONS S.A.S.",
        ],
        links: [{ label: "Política de resarcimiento", path: "/politica-de-resarcimiento" }],
      },
    ],
    relatedLinks: [
      { label: "Autorización de datos", path: "/autorizacion-tratamiento-datos" },
      { label: "Tarifas", path: "/tarifas" },
    ],
  },

  "/tarifas": {
    eyebrow: "Legalidades",
    title: "Tarifas",
    subtitle:
      "Información sobre costos asociados al uso de MEU Aliado. Promovemos transparencia para que tomes decisiones informadas.",
    sections: [
      {
        id: "principio",
        title: "Principio de transparencia",
        paragraphs: [
          "En línea con nuestra misión de facilitar el acceso y comprensión de productos financieros, publicamos de forma clara los costos propios de la plataforma. Los productos financieros contratados con entidades aliadas tienen tarifas definidas por cada entidad.",
        ],
      },
      {
        id: "plataforma",
        title: "Uso de la plataforma",
        lists: [
          {
            title: "Servicios sin costo para el usuario",
            items: [
              "Registro y consulta básica de información centralizada.",
              "Simuladores de CDT y FIC en modalidad estándar.",
              "Acceso a contenidos de educación financiera y blog.",
            ],
          },
          {
            title: "Servicios con costo",
            items: [
              "Soluciones empresariales (CFO fraccional, gestión de caja, estudios especializados): según plan contratado. Ver página de planes.",
              "Servicios premium o personalizados: cotización previa según alcance.",
            ],
          },
        ],
        links: [{ label: "Dirección de innovación financiera — planes", path: "/empresas/direccion-de-innovacion-financiera/planes" }],
      },
      {
        id: "terceros",
        title: "Tarifas de entidades aliadas",
        paragraphs: [
          "Comisiones de administración de FIC, tasas de CDT, costos de pensiones voluntarias y demás cargos son determinados por la entidad financiera. MEU Aliado muestra la información disponible para comparar, pero la entidad contratante es quien define las condiciones finales.",
        ],
      },
      {
        id: "actualizacion",
        title: "Actualizaciones",
        paragraphs: [
          "Cualquier modificación a tarifas propias de MOU Solutions será publicada en esta página y comunicada por los canales oficiales con antelación razonable cuando aplique.",
        ],
      },
    ],
    cta: {
      title: "¿Dudas sobre un cobro?",
      text: "Contáctanos en consumidor@meu-aliado.com o al +57 322 908 0554. Te ayudamos a identificar si el cargo corresponde a MEU Aliado o a una entidad financiera aliada.",
    },
    relatedLinks: [
      { label: "Centro de ayuda", path: "/centro-de-ayuda" },
      { label: "Términos y condiciones", path: "/terminos-y-condiciones" },
    ],
  },

  "/autorizacion-tratamiento-datos": {
    eyebrow: "Legalidades",
    title: "Autorización para el tratamiento de datos personales",
    subtitle:
      "Texto de autorización que el titular otorga a MOU SOLUTIONS S.A.S. para el tratamiento de sus datos en el marco de MEU Aliado.",
    sections: [
      {
        id: "texto",
        title: "Texto de autorización",
        paragraphs: [
          `Yo, actuando en nombre propio o en representación de la persona jurídica que acredito, autorizo de manera previa, expresa e informada a ${ENTITY}, identificada con NIT ${NIT}, domiciliada en ${ADDRESS}, para recolectar, almacenar, usar, circular, transmitir y tratar mis datos personales conforme a la Política de Tratamiento de Datos Personales disponible en ${WEB}.`,
          "Declaro que he sido informado sobre las finalidades del tratamiento, que incluyen —entre otras— la validación de identidad, centralización de información financiera, gestión de productos solicitados, cumplimiento de obligaciones legales, prevención de fraude, atención de PQR y envío de comunicaciones relacionadas con el servicio.",
        ],
      },
      {
        id: "derechos",
        title: "Derechos del titular",
        paragraphs: [
          "Entiendo que puedo conocer, actualizar, rectificar y suprimir mis datos; revocar esta autorización; y presentar quejas ante la Superintendencia de Industria y Comercio, en los términos de la Ley 1581 de 2012 y normas complementarias.",
        ],
        links: [{ label: "Política completa de protección de datos", path: "/politica-tratamiento-datos" }],
      },
      {
        id: "medios",
        title: "Medios de otorgamiento",
        lists: [
          {
            items: [
              "Formularios electrónicos en la plataforma MEU Aliado.",
              "Casillas de aceptación al registrarse o vincular productos.",
              "Documentos físicos o grabaciones cuando el canal lo requiera.",
            ],
          },
        ],
      },
      {
        id: "contacto",
        title: "Ejercicio de derechos",
        paragraphs: [
          "Para consultas o reclamos sobre datos personales: protecciondatos@meu-aliado.com o +57 322 908 0554.",
        ],
      },
    ],
    relatedLinks: [
      { label: "SARLAFT", path: "/sarlaft" },
      { label: "Términos y condiciones", path: "/terminos-y-condiciones" },
    ],
  },

  "/politica-de-resarcimiento": {
    eyebrow: "Legalidades",
    title: "Política de Resarcimiento",
    subtitle:
      "Procedimiento para atender reclamaciones relacionadas con errores en transacciones o servicios prestados directamente por MOU SOLUTIONS S.A.S.",
    sections: [
      {
        id: "alcance",
        title: "Alcance",
        paragraphs: [
          "Esta política aplica a reclamaciones por presuntos errores atribuibles a MOU Solutions en el uso de la plataforma MEU Aliado. No cubre disputas sobre productos financieros contratados directamente con entidades aliadas, las cuales se rigen por los procedimientos de cada entidad.",
        ],
      },
      {
        id: "procedimiento",
        title: "Procedimiento",
        lists: [
          {
            items: [
              "Radicar la reclamación en consumidor@meu-aliado.com indicando nombre, documento, fecha del hecho y descripción detallada.",
              "Adjuntar soportes disponibles (capturas, referencias de transacción, comunicaciones).",
              "MOU Solutions acusará recibo en un plazo máximo de cinco (5) días hábiles.",
              "Investigación y respuesta en un plazo máximo de quince (15) días hábiles, prorrogables según la complejidad del caso.",
            ],
          },
        ],
      },
      {
        id: "resarcimiento",
        title: "Formas de resarcimiento",
        paragraphs: [
          "Si se confirma un error imputable a MOU Solutions, podremos ofrecer corrección de registros, reversión de cargos propios de la plataforma o compensación acordada con el usuario, según corresponda y dentro del marco legal aplicable.",
        ],
      },
      {
        id: "escalamiento",
        title: "Escalamiento",
        paragraphs: [
          "Si la respuesta no es satisfactoria, el usuario puede acudir a los mecanismos de atención al consumidor financiero y, cuando aplique, al Defensor del Consumidor Financiero.",
        ],
        links: [
          { label: "Atención al consumidor financiero", path: "/atencion-consumidor-financiero" },
          { label: "Defensor del consumidor financiero", path: "/defensor-consumidor-financiero" },
        ],
      },
    ],
    relatedLinks: [{ label: "Centro de ayuda", path: "/centro-de-ayuda" }],
  },

  "/transparencia": {
    eyebrow: "Consumidor",
    title: "Transparencia y acceso a la información",
    subtitle:
      "MOU SOLUTIONS S.A.S. garantiza el acceso a información pública de conformidad con la Ley 1712 de 2014 y el principio de máxima publicidad.",
    badges: [`${ENTITY} · NIT ${NIT}`],
    sections: [
      {
        id: "entidad",
        title: "Información de la entidad",
        paragraphs: [
          `Razón social: ${ENTITY}. NIT: ${NIT}. Domicilio: ${ADDRESS}. Sitio web: ${WEB}. Teléfono: ${PHONE}.`,
          "MEU Aliado opera como auxiliar del ecosistema financiero colombiano, centralizando información y facilitando la intermediación de productos financieros bajo el modelo de finanzas abiertas.",
        ],
      },
      {
        id: "normativa",
        title: "Normativa aplicable",
        lists: [
          {
            items: [
              "Ley 1712 de 2014 — Transparencia y derecho de acceso a la información pública.",
              "Ley 1581 de 2012 — Protección de datos personales.",
              "Normativa del consumidor financiero y disposiciones sectoriales vigentes.",
            ],
          },
        ],
      },
      {
        id: "documentos",
        title: "Documentos y políticas publicadas",
        lists: [
          {
            items: [
              "Política de tratamiento de datos personales.",
              "Términos y condiciones de uso.",
              "Política SARLAFT y gobierno corporativo.",
              "Tarifas y política de resarcimiento.",
            ],
          },
        ],
        links: [
          { label: "Protección de datos", path: "/politica-tratamiento-datos" },
          { label: "Gobierno corporativo", path: "/gobierno-corporativo" },
        ],
      },
      {
        id: "solicitudes",
        title: "Solicitudes de información",
        paragraphs: [
          "Las solicitudes de información pública pueden enviarse a transparencia@meu-aliado.com indicando descripción clara del documento o información requerida. Responderemos dentro de los plazos establecidos por la ley.",
        ],
      },
      {
        id: "pqrs",
        title: "Participación y PQR",
        paragraphs: [
          "Los usuarios pueden presentar peticiones, quejas, reclamos y sugerencias a través de los canales de atención al consumidor financiero.",
        ],
        links: [{ label: "Atención al consumidor financiero", path: "/atencion-consumidor-financiero" }],
      },
    ],
    cta: {
      title: "Transparencia como valor",
      text: missionSnippet,
    },
    relatedLinks: [
      { label: "Defensor del consumidor financiero", path: "/defensor-consumidor-financiero" },
      { label: "Centro de ayuda", path: "/centro-de-ayuda" },
    ],
  },

  "/atencion-consumidor-financiero": {
    eyebrow: "Consumidor",
    title: "Atención al consumidor financiero",
    subtitle:
      "Canales y tiempos de respuesta para peticiones, quejas, reclamos y sugerencias de usuarios de MEU Aliado.",
    sections: [
      {
        id: "compromiso",
        title: "Nuestro compromiso",
        paragraphs: [
          "En MEU Aliado ponemos al usuario en el centro. Atendemos sus solicitudes con claridad, trazabilidad y respeto por los derechos del consumidor financiero, en coherencia con nuestra misión de intermediación transparente.",
        ],
      },
      {
        id: "canales",
        title: "Canales de atención",
        lists: [
          {
            items: [
              `Teléfono: ${PHONE} — lunes a viernes, 8:00 a.m. a 5:00 p.m. (hora Colombia).`,
              "Correo: consumidor@meu-aliado.com",
              "Formulario web en la sección Centro de ayuda.",
              "Correo postal: " + ADDRESS,
            ],
          },
        ],
      },
      {
        id: "pqrs",
        title: "Procedimiento PQR",
        lists: [
          {
            items: [
              "Radicación: incluya nombre, documento, medio de contacto y descripción del caso.",
              "Acuse de recibo: máximo 5 días hábiles con número de radicado.",
              "Respuesta: máximo 15 días hábiles, prorrogables según la ley cuando el caso lo requiera.",
              "Seguimiento: puede consultar el estado con su número de radicado.",
            ],
          },
        ],
      },
      {
        id: "derechos",
        title: "Derechos del consumidor",
        paragraphs: [
          "Entre otros, derecho a información clara, trato digno, solución oportuna de reclamaciones y acceso a mecanismos de escalamiento ante el Defensor del Consumidor Financiero cuando corresponda.",
        ],
        links: [{ label: "Defensor del consumidor financiero", path: "/defensor-consumidor-financiero" }],
      },
    ],
    sidebar: {
      title: "Datos de contacto",
      lines: [`${ENTITY}`, `NIT ${NIT}`, ADDRESS, PHONE],
    },
    relatedLinks: [
      { label: "Política de resarcimiento", path: "/politica-de-resarcimiento" },
      { label: "Transparencia", path: "/transparencia" },
    ],
  },

  "/defensor-consumidor-financiero": {
    eyebrow: "Consumidor",
    title: "Defensor del consumidor financiero",
    subtitle:
      "Información sobre el mecanismo de defensoría del consumidor financiero y cuándo acudir a él.",
    sections: [
      {
        id: "que-es",
        title: "¿Qué es el Defensor del Consumidor Financiero?",
        paragraphs: [
          "Es un mecanismo de protección del usuario financiero que actúa de forma imparcial para facilitar la solución de conflictos entre consumidores y entidades vigiladas o relacionadas con el sector financiero, cuando no se ha logrado una respuesta satisfactoria por los canales ordinarios de atención.",
        ],
      },
      {
        id: "cuando",
        title: "¿Cuándo acudir?",
        lists: [
          {
            items: [
              "Cuando agotó el trámite de PQR ante MOU Solutions sin solución satisfactoria.",
              "Cuando la reclamación versa sobre un producto o servicio financiero y existe relación con entidad vigilada.",
              "Cuando requiere mediación independiente conforme a la normativa del consumidor financiero.",
            ],
          },
        ],
      },
      {
        id: "antes",
        title: "Antes de escalar",
        paragraphs: [
          "Le recomendamos agotar primero nuestros canales en Atención al consumidor financiero y conservar su número de radicado, comunicaciones y soportes. Esto agiliza cualquier proceso posterior.",
        ],
        links: [{ label: "Atención al consumidor financiero", path: "/atencion-consumidor-financiero" }],
      },
      {
        id: "info",
        title: "Información y orientación",
        paragraphs: [
          "MOU Solutions publicará en esta sección los datos de contacto del Defensor del Consumidor Financiero asignado conforme a la normativa vigente. Para orientación inicial, escríbanos a consumidor@meu-aliado.com.",
          "También puede consultar los canales oficiales de la Superintendencia Financiera de Colombia para verificar mecanismos de protección actualizados.",
        ],
      },
    ],
    cta: {
      title: "Tu confianza importa",
      text: visionSnippet,
    },
    relatedLinks: [
      { label: "Centro de ayuda", path: "/centro-de-ayuda" },
      { label: "Política de resarcimiento", path: "/politica-de-resarcimiento" },
    ],
  },
};

export const institutionalPaths = Object.keys(institutionalPages);
